import { createColumnHelper } from '@tanstack/react-table'

import { Radio, Text } from '@chakra-ui/react'

import { IncidentType } from '@/graphql/generated/schemas'
import { formatDateTime } from '@/utils/formatDateTime'

import { IncidentOptionI, TypeFilterOptionI } from '../../types/types'
import { formatEnumLabel } from '../../utils/formatEnumLabel'

const columnHelper = createColumnHelper<IncidentOptionI>()

export const TYPE_FILTER_OPTIONS: TypeFilterOptionI[] = [
  { label: 'All', value: null },
  { label: 'Forced Entry', value: IncidentType.ForcedEntry },
  { label: 'Tailgating', value: IncidentType.Tailgating },
]

export const incidentTableColumns = [
  columnHelper.display({
    id: 'select',
    header: '',
    size: 20,
    cell: ({ row, table }) => {
      const selectedId = (table.options.meta as { selectedId?: string })
        ?.selectedId
      return (
        <Radio
          isChecked={row.original.id === selectedId}
          onChange={() => {}}
          pointerEvents='none'
        />
      )
    },
  }),
  columnHelper.accessor('incidentId', {
    header: 'Incident ID',
    size: 110,
  }),
  columnHelper.accessor('type', {
    header: 'Type',
    size: 90,
    cell: ({ getValue }) => (
      <Text as='span' fontSize='11px' fontWeight={600}>
        {formatEnumLabel(getValue())}
      </Text>
    ),
  }),
  columnHelper.accessor('createdAt', {
    header: 'Created',
    size: 155,
    cell: ({ getValue }) => (
      <Text as='span' fontSize='11px'>
        {formatDateTime(getValue())}
      </Text>
    ),
  }),
  columnHelper.accessor('status', {
    header: 'Status',
    size: 90,
    cell: ({ getValue }) => (
      <Text as='span' fontSize='11px' fontWeight={600}>
        {formatEnumLabel(getValue())}
      </Text>
    ),
  }),
]
